import api from "@/api";

import deepClone from "@/utils/deep-clone";
const defaultActionItem = {
    owners: [],
    localTeams: [],
    content: "",
    description: "",
};
const state = {
    actionItems: {},
    recommendations: [],
};

const getters = {
    getById(state) {
        return id => deepClone(state.actionItems[id]) || defaultActionItem;
    },
    list(state) {
        return deepClone(
            Object.values(state.actionItems)?.filter(
                a => a.type !== "surveyActionItemSuggestion",
            ) || [],
        );
    },
    recommendations(state) {
        return deepClone(state.recommendations);
    },
};

const actions = {
    create({ commit }, { payload, surveyId }) {
        return api.post(`/api/surveys/${surveyId}/action-items`, payload).then(x => {
            commit("updateActionItems", { data: [x.data] }); // update data
            return x;
        });
    },
    update({ commit }, { payload }) {
        return api.patch(`/api/surveys/${payload.survey}/action-items`, payload).then(res => {
            const data = res?.data ?? {};
            commit("updateActionItem", { data });
        });
    },

    list({ commit }, { payload: { surveyId } }) {
        const types = ["surveyUserActionItem", "surveyTeamActionItem", "surveyCompanyActionItem"];
        return api
            .get(`/api/surveys/${surveyId}/action-items?type[]=${types.join("&type[]=")}`)
            .then(res => {
                const data = res?.data ?? {};
                commit("updateActionItems", { data, reset: true });
            });
    },
    listRecommendations({ commit }, { payload: { surveyId, lang, type } }) {
        return api
            .get(`/api/surveys/${surveyId}/action-items/recommendations?lang=${lang}&type=${type}`)
            .then(res => {
                const data = res?.data ?? {};

                commit("updateRecommendations", { data });
            });
    },
    get({ commit }, { payload: { surveyId, _id } }) {
        return api.get(`/api/surveys/${surveyId}/action-items/${_id}`).then(res => {
            const data = res?.data ?? {};

            commit("updateActionItems", { data: [data] });
        });
    },
    delete(
        { commit },
        {
            payload: {
                survey,
                actionItem: { _id },
            },
        },
    ) {
        return api.delete(`/api/surveys/${survey}/action-items/${_id}`).then(() => {
            commit("deleteActionItem", { _id });
        });
    },
};

const mutations = {
    updateActionItems(state, { data, reset }) {
        if (reset) {
            state.actionItems = {};
        }

        data.forEach(item => {
            state.actionItems = {
                ...state.actionItems,
                [item._id]: item,
            };
        });
    },
    updateActionItem(state, { data }) {
        state.actionItems[data._id] = data;
    },
    deleteActionItem(state, { _id }) {
        delete state.actionItems[_id];
        state.actionItems = { ...state.actionItems };
    },
    updateRecommendations(state, { data }) {
        state.recommendations = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
